import { gql } from '@apollo/client';

import { EHostType } from 'types';

export interface ICreateHostResponse {
  createHost: {
    id: number;
    alias: string;
  };
}

export const CREATE_HOST = gql`
  mutation createHost($input: HostInput!) {
    createHost(input: $input) {
      id
      alias
      type
    }
  }
`;

export interface IUpdateHostResponse {
  updateHost: {
    id: number;
    alias: string;
  };
}
export const UPDATE_HOST = gql`
  mutation updateHost($id: Int!, $input: HostInput!) {
    updateHost(id: $id, input: $input) {
      id
      alias
    }
  }
`;

export const HOST_TITLES = gql`
  query hostTitles {
    hostGroupTitles {
      id
      title
      priority
    }
  }
`;

export interface IHostResponse {
  hostOverview: {
    id: number;
    alias: string;
    position: number;
    group_id: number;
    type: EHostType;
  };
}
export const HOST = gql`
  query hostData($id: Int!) {
    hostOverview(id: $id) {
      id
      alias
      position
      group_id
      type
    }
  }
`;
